import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 size={28} className="animate-spin text-[#1B5E20]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (user.mustChangePassword && loc.pathname !== "/cambio-password") {
    return <Navigate to="/cambio-password" replace />;
  }
  // Trasportatore con PIN abilitato ma non ancora configurato → forza setup PIN
  if (user.ruolo === "TRASPORTATORE" && user.loginConPin && !user.pinSetUp
      && loc.pathname !== "/setup-pin" && loc.pathname !== "/cambio-password") {
    return <Navigate to="/setup-pin" replace />;
  }
  if (roles && roles.length && !roles.includes(user.ruolo)) {
    const fallback = user.ruolo === "TRASPORTATORE" ? "/giro" : "/dashboard";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
